module.exports = __webpack_public_path__ + "static/media/penghasilan.c599f203.png";